import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Banner,
} from '@riac/design-system';
import {
  TextField,
  Button,
  Typography,
} from '@up-riac/bespoke-ui';
import { LoginContext } from 'src/lib/LoginContext';
import { useHasMounted } from 'src/lib/useHasMounted';
import { Turnstile } from '@marsidev/react-turnstile';
import { MegaMenuLink } from 'src/components/Header/components/MegaMenu/MegaMenuLink';

export const HeaderAccountLoginPage = ({ id, onClose }: {id: string, onClose?: () => void}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<boolean | string>(false);
  const [turnstileToken, setTurnstileToken] = useState<any>();

  const hasMounted = useHasMounted();
  const turnstileRef = useRef(null);

  const submit = async (): Promise<void> => {
    setError(false);
    setSuccess(false);
    setSubmitting(true);
    const loginResult = await login(email, password, turnstileToken);
    setSubmitting(false);
    if(loginResult.success) {
      setSuccess(true);
    } else {
      setError(
        loginResult.error || 'An unknown login error occurred. Please contact customer support'
      );
      turnstileRef.current?.reset();
    }
  };

  const { login, isLoggedIn } = useContext(LoginContext);

  const [cookieError, setCookieError] = useState(false);
  useEffect(() => {
    if(hasMounted) {
      let cookieEnabled = (navigator.cookieEnabled);

      if(typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') != -1);
      }
      cookieEnabled ? true : setCookieError(true);
    }
  }, [hasMounted]);

  return (
    <form id={id} className='gap-4 px-3 w-full self-center flex flex-col items-stretch' onSubmit={(e) => {
      submit();
      e.preventDefault();
    }}>
      <TextField
        value={email}
        onChange={(val) => {
          setEmail(val);
        }}
        autoComplete='email'
        isDisabled={submitting || success}
        label='Email'
        focusOnMount
        type='email'
        isRequired
        id={id ? `${id}-email` : undefined}
      />
      <TextField
        value={password}
        onChange={(val) => setPassword(val)}
        autoComplete='password'
        type='password'
        isDisabled={submitting || success}
        label='Password'
        isRequired
        id={id ? `${id}-password` : undefined}
      />
      <div>
        <MegaMenuLink onPress={onClose} to='/login/password-reset' label='Forgot password?' id={id ? `${id}-forgot-password` : undefined}/>
      </div>
      <Turnstile
        siteKey={window.TURNSTILE_SITE_KEY}
        options={{
          theme: 'dark',
          size: 'flexible',
        }}
        onSuccess={(token) => {
          setTurnstileToken(token);
          console.log('token', { token });
        }}
        onError={(error) => {
          setError('There was an error with the CAPTCHA. Please try again.');
          console.log('turnstile error', error);
        }}
        ref={turnstileRef}
        id={id ? `${id}-turnstile` : undefined}
      />
      <Button
        type='submit'
        size='lg'
        isDisabled={!turnstileToken || submitting || success}
        buttonType='outlined'
        className='text-center block'
        fullWidth
        id={id ? `${id}-submit` : undefined}
      >
        Log In
      </Button>
      {cookieError
        && <Banner
          id={id ? `${id}-cookie-error` : undefined}
          color='error'
          children={<div className='flex flex-col gap-3'>
            <Typography>
              Your web browser has cookies disabled.
            </Typography>
            <Typography>
              Please enable cookies to Login. If you need help, please contact our customer support.
            </Typography>
          </div>}
        />
      }
      {error
        && <Typography id={id ? `${id}-error` : undefined} className='text-error'>{error}</Typography>
      }
    </form>
  );
};
